"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFReceiverObject = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
let RFReceiverObject = class RFReceiverObject extends core_1.DataObject {
};
exports.RFReceiverObject = RFReceiverObject;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], RFReceiverObject.prototype, "rxSensitivity", void 0);
exports.RFReceiverObject = RFReceiverObject = tslib_1.__decorate([
    (0, core_1.SerializableObject)()
], RFReceiverObject);
//# sourceMappingURL=RFReceiverObject.js.map